import { useRef } from 'react'
import { grid } from '@ocean/configs'
import GridCarouselContext from './GridCarousel.context'
import { CarouselWrapper, CarouselContainer } from './GridCarousel.styled'
import { GridCarouselControl } from './components'

const { breakpoints } = grid

const RESPONSIVE_GRID = {
  lg: {
    breakpoint: { max: 10000, min: breakpoints.md },
    items: 3,
  },
  md: {
    breakpoint: { max: breakpoints.md, min: breakpoints.sm },
    items: 2,
  },
  sm: {
    breakpoint: { max: breakpoints.sm, min: 0 },
    items: 1,
  },
}

const GridCarousel: React.FC = ({ children }) => {
  const carouselRef = useRef(null)

  return (
    <GridCarouselContext.Provider value={true}>
      <CarouselWrapper data-test='GridCarousel'>
        <CarouselContainer
          ref={carouselRef}
          ssr={false}
          responsive={RESPONSIVE_GRID}
          arrows={false}
          swipeable
          itemClass='grid-carousel-item'
          customButtonGroup={<GridCarouselControl carouselRef={carouselRef} />}
        >
          {children}
        </CarouselContainer>
      </CarouselWrapper>
    </GridCarouselContext.Provider>
  )
}

export default GridCarousel
